module.exports = __webpack_public_path__ + "media/images/wfc/auth-bg-13cf490dc32c44d44d6d43c92f5e5053.png";